import { useState, useCallback } from "react";

const useContentModal = (contentType = "content") => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    contentId: null,
  });

  const shouldUseModal = useCallback(() => {
    // Always use modal overlay for consistent behavior
    return true;
  }, []);

  const openContent = useCallback(
    (contentId, navigate) => {
      if (shouldUseModal()) {
        // Open in modal
        setModalState({
          isOpen: true,
          contentId: contentId,
        });
      } else {
        // Navigate to content page (existing behavior)
        navigate(`/${contentType}/${contentId}`);
      }
    },
    [shouldUseModal, contentType],
  );

  const closeModal = useCallback(() => {
    setModalState({
      isOpen: false,
      contentId: null,
    });
  }, []);

  return {
    modalState,
    shouldUseModal: shouldUseModal(),
    openContent,
    closeModal,
  };
};

export default useContentModal;
